export const BUDGET_URL = '/api/proxy/rnb/pvt/budget'
